import React from 'react'
import AnimationAIcon from 'components_v2/Icons/AnimationAIcon'
import AnimationLIcon from 'components_v2/Icons/AnimationLIcon'
import AnimationOIcon from 'components_v2/Icons/AnimationOIcon'
import { Flex } from 'ui/acro'
import styled, { keyframes } from 'styled-components'

const duration = 0.75

const animateA = keyframes`
  0% {
    fill: transparent;
  }
  25% {
    fill: black;
  }
  75% {
    fill: black;
  }
  100% {
    fill: black;
  }
`
const animateL = keyframes`
  0% {
    fill: transparent;
  }
  25% {
    fill: transparent;
  }
  75% {
    fill: black;
  }
  100% {
    fill: black;
  }
`
const animateO = keyframes`
  0% {
    fill: transparent;
  }
  25% {
    fill: transparent;
  }
  75% {
    fill: transparent;
  }
  100% {
    fill: black;
  }
`
const FlexBox = styled(Flex)`
  grid-column: 1 / -1;
  align-items: baseline;
  gap: 3px;
  justify-content: center;
  margin: 10vh 0;
  .animation-fill-1 svg {
    animation: ${animateA} ${duration}s linear infinite;
  }
  .animation-fill-2 svg {
    animation: ${animateL} ${duration}s linear infinite;
  }
  .animation-fill-3 svg {
    animation: ${animateO} ${duration}s linear infinite;
  }
`

const AloMovesAnimation = () => {
  return (
    <FlexBox>
      <AnimationAIcon />
      <AnimationLIcon />
      <AnimationOIcon />
    </FlexBox>
  )
}

export default AloMovesAnimation
